import { render, staticRenderFns } from "./Alteration.vue?vue&type=template&id=3919662a&scoped=true&"
import script from "./Alteration.vue?vue&type=script&lang=js&"
export * from "./Alteration.vue?vue&type=script&lang=js&"
import style0 from "./Alteration.vue?vue&type=style&index=0&id=3919662a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3919662a",
  null
  
)

export default component.exports